import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { head, isEmpty } from 'lodash'

import CartItems from '../containers/CartItems'

import CartDetails from '../containers/CartDetails'
import Button from './Button'
import TabOrderCartDetails from '../components/tabs/TabOrderCartDetails'
import { USE_RICH_CHECKOUT } from '../constants'

import styles from './CartSidebar.module.scss'
import networkConnected from '../utils/networkConnected'
import ConfirmSplitPaymentDialog from './dialog/ConfirmSplitPaymentDialog'

const CartSidebar = ({ topButton, bottomButton, showCardReaderModal, onCardReaderModalClose, clearCart, hasCartItems, order, onMobileWallet, history, discountsAvailable, noOpTenders, className, setMenus, stands, menu, cashEnabled, networkAvailable, ticketEnabled, tipEnabled }) => {
  const classNames = cn(styles.cartSidebar, className)
  const [showSplitPayDialog, setShowSplitPayDialog] = useState(false)

  const isTab = !isEmpty(order)
  const richCheckoutAvailable = USE_RICH_CHECKOUT === 'true'
  let modal = null
  let cartFooterElement = null

  useEffect(() => {
    // if offline
    networkConnected().catch(() => {
      if(menu) setMenus(head(stands), menu)
    })
  }, [menu])

  if (showCardReaderModal) {
    modal = (
      history.push({
        pathname: `/card-reader`,
      })
    )
  }

  if (showSplitPayDialog) {
    modal = (
      <ConfirmSplitPaymentDialog
        onClose={() => setShowSplitPayDialog(false)}
        fromConcessions={true}
      />
    )
  }
  
  const trueExtraButtonCount = !!cashEnabled +
   !isEmpty(noOpTenders) +
   !!discountsAvailable +
   !!richCheckoutAvailable +
   !!networkAvailable + ticketEnabled

  let extraButtonCount
  if (trueExtraButtonCount > 3) {
    extraButtonCount = 3
  } else {
    extraButtonCount = trueExtraButtonCount
  }

  const extraButtonClassName = cn([styles.checkout, extraButtonCount === 1 ? styles.long : styles.short])
  const showOtherButton = trueExtraButtonCount > 3 

  let buttons = [
    <Button
      className={cn([styles.checkout, extraButtonCount < 3 ? styles.long : styles.short])}
      disabled={topButton.disabled}
      onClick={topButton.onClick}
    >
      {topButton.text}
    </Button>
  ]
  
  if (cashEnabled) {
    buttons.push(<Button
      className={extraButtonClassName}
      onClick={bottomButton.onClick}
    >
      {bottomButton.text}
    </Button>)
  }

  if (discountsAvailable) {
    buttons.push(<Button
      className={extraButtonClassName}
      onClick={() => history.push('/concession-order/select-discount')}
    >{"Discount"}</Button>)
  }

  if ((buttons.length < 3 || (buttons.length < 4 && !showOtherButton)) && richCheckoutAvailable) {
    buttons.push(<Button
      className={extraButtonClassName}
      onClick={onMobileWallet}
    >{"App"}</Button>)
  }

  
  if ((buttons.length < 3 || (buttons.length < 4 && !showOtherButton)) && ticketEnabled) {
    buttons.push(<Button
      className={extraButtonClassName}
      onClick={() => {
        if (tipEnabled) {
          history.push({
            pathname: '/signature',
            state: {
              addTipThenRedirectPath: '/ticket'
            }
          })
        } else {
          history.push('/ticket')
        }
      }}
      >
      Ticket
    </Button>
  )
}

if ((buttons.length < 3 || (buttons.length < 4 && !showOtherButton)) && networkAvailable) {
  buttons.push(<Button
    className={extraButtonClassName}
    onClick={() => setShowSplitPayDialog(true)}
  >
    Split
  </Button>)
}

  if (showOtherButton || ( buttons.length < 4 && !isEmpty(noOpTenders))) {
    buttons.push(<Button
      className={extraButtonClassName}
      onClick={() => history.push('/tender-selection')}
    >
      Other
    </Button>)
  }

  if (hasCartItems) {
    cartFooterElement = (
      <div className={styles.cartDetailsContainer}>
        <CartDetails
          className={styles.cartDetails}
          order={order}
          lineItemPrefix={isTab ? 'new' : ''}
        />
        <div className={styles.buttonContainer}>
          {buttons}
        </div>
      </div>
    )
  }

  return (
    <div className={classNames}>
      {hasCartItems && 
        <div className={styles.clearContainer}>
          <span className={styles.headerText}>New Order</span>
          <span className={styles.clear} onClick={clearCart}>Clear</span>
        </div>
      }
      <div className={styles.border}></div>
      {isTab && <TabOrderCartDetails order={order}/>}
      <CartItems className={styles.cartItems} />
      {cartFooterElement}
      {modal}
    </div>
  )
}

CartSidebar.defaultProps = {
  clearCart: () => {},
  order: {},
}

CartSidebar.propTypes = {
  clearCart: PropTypes.func,
  hasCartItems: PropTypes.bool,
  className: PropTypes.string,
  order: PropTypes.object
}

export default CartSidebar
